import React from 'react';
import { Gradient } from '../Gradient';

const Magic = ({ type, className = '', color = '#737373' }) => {
  return (

<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M8.00008 4.99994L7.48423 6.39401C6.80781 8.22198 6.4696 9.13599 5.80284 9.8028C5.13608 10.4695 4.22208 10.8077 2.39407 11.4842L1 12L2.39407 12.5158C4.22208 13.1923 5.13608 13.5305 5.80284 14.1973C6.4696 14.8641 6.80781 15.7781 7.48423 17.606L8.00008 19.0001L8.51589 17.606C9.1924 15.7781 9.5306 14.8641 10.1973 14.1973C10.8641 13.5305 11.7781 13.1923 13.6061 12.5158L15.0002 12L13.6061 11.4842C11.7781 10.8077 10.8641 10.4695 10.1973 9.8028C9.5306 9.13599 9.1924 8.22198 8.51589 6.39401L8.00008 4.99994Z" 
stroke={type === 'plain' ? color : 'url(#globalGradient)'}
      strokeWidth="1" 
      strokeLinecap="round" 
      strokeLinejoin="round"/>

<path d="M16 1L15.7789 1.59746C15.489 2.38089 15.3441 2.77261 15.0582 3.05835C14.7725 3.34411 14.3808 3.48906 13.5974 3.77895L12.9999 4.00004L13.5974 4.22112C14.3808 4.51101 14.7725 4.65596 15.0582 4.94172C15.3441 5.22746 15.489 5.61919 15.7789 6.40261L16 7.00007L16.2211 6.40261C16.511 5.61919 16.6559 5.22746 16.9417 4.94171C17.2274 4.65596 17.6191 4.51101 18.4025 4.22112L19 4.00004L18.4025 3.77895C17.6191 3.48906 17.2274 3.34411 16.9417 3.05835C16.6559 2.77261 16.511 2.38089 16.2211 1.59746L16 1Z" 
stroke={type === 'plain' ? color : 'url(#globalGradient)'}
      strokeWidth="1" 
      strokeLinecap="round" 
      strokeLinejoin="round"/>
      <Gradient className={className} />
</svg>

  );
};

export default Magic;